import ProjectStore from '../store/ProjectStore'
import makeRpcCall from '../util/jquery_rpc'
import messageResource from '../messageResource'
import {mergeCustomersProjectsFromRPC, replaceTypesOfWorkFromRPC} from '../store/StoreUtils'
import {customerFromRpc, projectFromRpc} from '../taskManagement/utils'
import {EntityTextLimits} from 'constants'
import {downloadJsonAsCSV} from '../csv/utils'

/**
 * Created by evdokimov on 01.06.2016.
 */

export default function LoadTasksFromCSVManager()
{}

LoadTasksFromCSVManager.prototype = _.create(Object.prototype, {
    init: function(actionUrl, csvSeparator, errorCodes, errorMessages, successTaskCreationCallback, onLoadCustomersProjectsCallback, onLoadTypesOfWorkCallback)
    {
        this.actionUrl = actionUrl;
        this.successTaskCreationCallback = successTaskCreationCallback;
        this.onLoadCustomersProjectsCallback = onLoadCustomersProjectsCallback;
        this.onLoadTypesOfWorkCallback = onLoadTypesOfWorkCallback;
        this.duplicateTaskErrorCode = 'DUPLICATE';

        this.importPreviewSection = $("#importPreviewSection");
        this.resultTableContainer = $("#resultTableContainer");
        this.template = this.createTemplate();

        this.resulTasksSuccessTableLink = $("#resultTasksSuccessTableLink");
        this.resultTasksDuplicatesTableLink = $("#resultTasksDuplicatesTableLink");
        this.resulTasksErrorTableLink = $("#resultTasksErrorTableLink");
        this.errorTooltip = new TableTooltip().init("incorrectFieldTooltip");
        this.errorTooltipTextPlaceholder = $("#incorrectFieldTooltip_textPlaceholder");
        this.toImportInfoContainer = $("#toImportInfoContainer");
        this.resultInfoContainer = $("#loadTasksFromCSVPopup_resultContent");

        this.csvSeparator = csvSeparator;
        var separatorTextValue = csvSeparator == "\t" ? messageResource.getMessage("import_csv_tasks_info.text.tab_separator") : csvSeparator;
        $("#atSeparatorValue").text(separatorTextValue);

        this.encoding = "UTF-8";

        this.errorCodesMap = _.invert(errorCodes);
        this.errorCodesMessages = errorMessages;

        return this;
    },

    columnOrder: ["customer", "project", "task", "description", "typeOfWork", "deadline", "estimate"],

    getColumnNames: function()
    {
        return {
            rowId: messageResource.getMessage("import_csv_tasks.columns.row"),
            customer: messageResource.getMessage('common.Customer'),
            project: messageResource.getMessage('common.Project'),
            task: messageResource.getMessage('common.Task'),
            description: messageResource.getMessage('import_csv_tasks.columns.description'),
            deadline: messageResource.getMessage('import_csv_tasks.columns.deadline'),
            typeOfWork: messageResource.getMessage('import_csv_tasks.columns.type_of_work'),
            estimate: messageResource.getMessage('import_csv_tasks.columns.estimate')
        }
    },

    getErrorDescription: function()
    {
        var msg = messageResource.getEscapedMessage;
        var nameText = messageResource.getMessage("import_csv_tasks.error.long_field_name");
        var longMsg = function(args)
        {
            var text = (args[3] == "description") ? args[0] : args[0] + " " + nameText;
            return messageResource.getEscapedMessage('import_csv_tasks.error.long_field', [text]) +
                   " <span style='white-space: nowrap;'>(" + args[1] + " / " + args[2] + ")<span>";
        };

        var lowerCaseMsg = function(key, args)
        {
            return messageResource.getEscapedMessage(key, [args[0].toLowerCase()]);
        };

        return {
            EMPTY_FIELD: {text: _.bind(msg, messageResource, "import_csv_tasks.error.empty_field"), width: 110},
            TOO_LONG_FIELD: {text: longMsg, width: 150},
            PARSE_ERROR: {text: _.bind(msg, messageResource, 'import_csv_tasks.error.parse_error'), width: 130},
            INCORRECT: {text: _.bind(msg, messageResource, 'import_csv_tasks.error.incorrect_value'), width: 130},
            ARCHIVED: {text: _.bind(msg, messageResource, 'import_csv_tasks.error.archived'), width: 110},
            NOT_EXISTS: function(columnType){
                if(columnType === 'typeOfWork') {
                    return {
                        text: _.partial(lowerCaseMsg, 'import_csv_tasks.error.not_exists.type_of_work'),
                        width:165
                    }
                }
                else {
                    return {
                        text: _.partial(lowerCaseMsg, 'import_csv_tasks.error.not_exists'),
                        width:170
                    }
                }
            },
            NOT_ASSIGNED: {text: _.bind(msg, messageResource, 'import_csv_tasks.error.not_assigned'), width: 120},
            DUPLICATE: {text: _.bind(msg, messageResource, 'import_csv_tasks.error.duplicate'), width: 80}
        }
    },

    getColumnMaxSizeErrMap: function()
    {
        return {
            customer: EntityTextLimits.MAX_CPT_NAME,
            project: EntityTextLimits.MAX_CPT_NAME,
            task: EntityTextLimits.MAX_CPT_NAME,
            description: EntityTextLimits.MAX_CPT_DESCRIPTION,
            typeOfWork: EntityTextLimits.MAX_BILLING_TYPE_NAME,
        }
    },

    isDuplicateTaskError: function(error)
    {
        return error.task == this.duplicateTaskErrorCode;
    },

    _initErrorTooltip: function()
    {
        var hoverFn = _.bind(this._moveTooltip, this);
        this.resultTableContainer.hover(hoverFn, _.bind(this._hideTooltip, this));
        this.resultTableContainer.mousemove(hoverFn);
    },

    _setTooltipMessage: function(target)
    {
        var errorType = target.attr("errorType");
        var columnType = target.attr("column");
        var column = this.columnNames[columnType];
        var length = target.attr("textLength");
        var maxLength = this.columnMaxSizeErrMap[columnType];
        var description = this.errorDescription[errorType];
        if(_.isFunction(description))
            description = description(columnType);
        this.errorTooltipTextPlaceholder.width(description.width);
        this.errorTooltipTextPlaceholder.html(description.text([column, length, maxLength, columnType]));
    },

    _moveTooltip: function(event)
    {
        var targetEvent = event.originalEvent.target;
        if (_.isUndefined(targetEvent))
            targetEvent = event.originalEvent.srcElement;

        var target = $(targetEvent);
        if (!target.hasClass("withError"))
        {
            this._hideTooltip();
            return;
        }

        this._setTooltipMessage(target);
        this.errorTooltip.show();
        this.errorTooltip.move(calculateTooltipOffset(this.errorTooltip, event));
    },

    _hideTooltip: function()
    {
        this.errorTooltip.hide();
    },

    collectRowsWithErrors: function(data)
    {
        var rowsMap = {};
        _.each(data.table, function(row)
        {
            rowsMap[row.rowId] = row;
        });

        var self = this;
        var duplicateArray = [];
        var errorArray = [];
        var duplicatesJSON = [];
        var errorsJSON = [];
        var errorIds = [];
        var duplicateIds = [];
        _.each(data.errors, function(error)
        {
            var row = rowsMap[error.rowId];
            if (self.isDuplicateTaskError(error))
            {
                duplicateIds.push(error.rowId);
                duplicateArray.push({row: row, error: error});
                duplicatesJSON.push(row);
            }
            else
            {
                errorIds.push(error.rowId);
                errorArray.push({row: row, error: error});
                errorsJSON.push(row);
            }
        });

        return {
            duplicates: duplicateArray,
            errors: errorArray,
            duplicatesJSON: duplicatesJSON,
            errorsJSON: errorsJSON,
            duplicateIds: duplicateIds,
            errorIds: errorIds
        };
    },

    updateTableData: function(result)
    {
        var columns = this.getPresentedTableColumns(result.columns);
        var collectedErrors = this.collectRowsWithErrors(result);

        this.resultTable = result.table;
        this.previewErrors = {errors: collectedErrors.errorIds, duplicates: collectedErrors.duplicateIds};
        this.columns = columns;

        this.createTable({
                             columnNames: this.columnNames,
                             columns: columns,
                             table: result.table,
                             duplicates: collectedErrors.duplicates,
                             errors: collectedErrors.errors
                         });

        this.createCSVWithDuplicatesLink("#downloadCSVWithDuplicatesLink", columns, collectedErrors.duplicatesJSON);
        this.createCSVWithErrorsLink("#downloadCSVWithErrorsLink", columns, collectedErrors.errorsJSON);
        this.fillImportInfo(result["importCounter"]);

        var errorsNumber = collectedErrors.duplicatesJSON.length + collectedErrors.errorsJSON.length;
        var showTableLinks = errorsNumber > 0;
        this.popup.showInnerContent(showTableLinks);

        var resultSize = result.table.length;
        if (resultSize > 2000)
        {
            return _.bind(this.onCSVPartialLoadSuccess, this, resultSize, columns, errorsNumber, collectedErrors, showTableLinks);
        }

        this.onCSVPartialLoadSuccess(resultSize, columns, errorsNumber, collectedErrors, showTableLinks);
        return null;
    },

    onCSVPartialLoadSuccess: function(resultSize, columns, errorsNumber, collectedErrors, showTableLinks)
    {
        //must be after displaying table to calculate real width of columns
        this.applyTableScrollHacks(columns);
        this.addScroll();

        this.markRowsWithProblems(columns, this.resultTableContainer, collectedErrors.duplicates, "duplicate");
        this.markRowsWithProblems(columns, this.resultTableContainer, collectedErrors.errors, "withError");

        if (showTableLinks && (resultSize - errorsNumber == 0))
        {
            this.popup.toggleImportEnabled(false);
            if (collectedErrors.duplicatesJSON.length > 0)
                this.showDuplicatesFn();
            else
                this.showErrorsFn();
        }
        else
        {
            this.popup.toggleImportEnabled(resultSize > 0);
        }
    },

    showPopup: function()
    {
        this.affectedProjectIds = {};

        if (_.isUndefined(this.popup))
        {
            this.popup = new LoadTasksFromCSVPopup().init(this.actionUrl, _.bind(this.onCSVLoadSuccess, this),
                                                          _.bind(this.completeImport, this), _.bind(this.reloadPageWithFilter, this),
                                                          _.bind(this.cleanTable, this));

            this.columnNames = this.getColumnNames();
            this.errorDescription = this.getErrorDescription();
            this.columnMaxSizeErrMap = this.getColumnMaxSizeErrMap();
            this.initTableViewLinks();
            this.initSampleCSV();
            this._initErrorTooltip();
        }

        this.popup.restartImport();
        this.popup.show();
    },

    reloadPageWithFilter: function()
    {
        // Only return projects, which were successfully added to the store
        const projectIdsArray = Object.keys(this.affectedProjectIds).filter(id => ProjectStore.get(id)).map(id => Number(id))
        if (projectIdsArray.length > 0)
            this.successTaskCreationCallback(projectIdsArray);
    },

    cleanTable: function()
    {
        this.resultTable = null;
        this.previewErrors = null;
        this.resultTableContainer[0].innerHTML = "";
    },

    completeImport: function(successCallback, errorCallback, progressCallback)
    {
        var self = this;
        var maxChunkSize = 500;
        var table = this.resultTable;

        this.operationId = null;

        var i = 0;
        var makeCall = function(successCallback, errorPrefix)
        {
            var chunk = table.slice(i, i + maxChunkSize);
            makeRpcCall("CsvImportTasksService.importTasks", [chunk, i, table.length, self.operationId],
                        successCallback, errorCallback, errorPrefix
            );
        };

        var combinedResult = {
            errors: [],
            importCounter: {
                customersCount: 0,
                projectsCount: 0,
                tasksCount: 0,
                typesOfWorkCount: 0,
                projectIds: []
            }
        };
        var combineResults = function(chunkResult)
        {
            combinedResult.errors = combinedResult.errors.concat(chunkResult.errors);
            combinedResult.importCounter.customersCount += chunkResult.importCounter.customersCount;
            combinedResult.importCounter.projectsCount += chunkResult.importCounter.projectsCount;
            combinedResult.importCounter.tasksCount += chunkResult.importCounter.tasksCount;
            combinedResult.importCounter.typesOfWorkCount += chunkResult.importCounter.typesOfWorkCount;
            combinedResult.importCounter.projectIds = _.union(combinedResult.importCounter.projectIds,
                                                              chunkResult.importCounter.projectIds);
        };

        var errPrefix = messageResource.getMessage("import_csv_tasks.error.some_data_imported");
        var successProcessor = function(result)
        {
            self.operationId = result.operationId;

            combineResults(result);
            i += maxChunkSize;

            progressCallback((i / table.length) * 100);

            if (i < table.length)
            {
                makeCall(successProcessor, errPrefix);
            }
            else
            {
                const done = () => {
                    self.completeImportSuccessHandler(combinedResult);
                    successCallback();
                }

                self.updateCustomersProjectsIfNeeded(combinedResult.importCounter)
                    .then(() => self.updateTypesOfWorkIfNeeded(combinedResult.importCounter.typesOfWorkCount))
                    .then(() => done())
            }
        };

        progressCallback((maxChunkSize / table.length) * 50);
        makeCall(successProcessor);
    },

    updateCustomersProjectsIfNeeded: function(importCounter) {
        const self = this
        return new Promise((resolve, reject) => {
            // TODO need to load only assigned customer projects
            // TODO need to load assignnments too
            // After import is completed, ask for fresh customers/projects data
            if (importCounter.customersCount > 0 || importCounter.projectsCount > 0) {
                makeRpcCall("TaskManagementService.getAllCustomersProjects", [],
                    data => {
                        mergeCustomersProjectsFromRPC(data["customers"], data["projects"], true)
                        self.onLoadCustomersProjectsCallback({
                            customers: data["customers"].map(customerFromRpc),
                            projects: data["projects"].map(projectFromRpc),
                        })
                        resolve()
                    },
                    error => {
                        console.error(error)
                        reject()
                    }
                )
            } else {
                resolve()
            }
        })
    },

    updateTypesOfWorkIfNeeded: function(typesOfWorkCount) {
        const self = this
        return new Promise((resolve, reject) => {
            if (typesOfWorkCount > 0) {
                makeRpcCall("BillingTypeService.getAllTypes", [],
                    (typesOfWork) => {
                        replaceTypesOfWorkFromRPC(typesOfWork)
                        self.onLoadTypesOfWorkCallback(typesOfWork)
                        resolve()
                    },
                    error => {
                        console.error(error)
                        reject()
                    }
                )
            } else {
                resolve()
            }
        })
    },

    toggleImportDifferNote: function (collectedErrors) {
        var previewErrors = this.previewErrors;

        var isSameArrays = function (array1, array2) {
            return (array1.length == array2.length) &&
                   _.intersection(array1, array2).length == array1.length;
        };

        var errorListWasChanged = !isSameArrays(previewErrors.errors, collectedErrors.errorIds) ||
                                  !isSameArrays(previewErrors.duplicates, collectedErrors.duplicateIds);

        var hasDuplicates = collectedErrors.duplicates.length > 0;
        var hasErrors = collectedErrors.errors.length > 0;

        this.resultInfoContainer.toggleClass("errorListWasChanged", errorListWasChanged);
        var messageErrorKey = "";
        if(hasDuplicates){
            messageErrorKey = hasErrors? "import_csv_tasks.result.errors_differ.errors_and_duplicates" :"import_csv_tasks.result.errors_differ.duplicates";
        }
        else{
            messageErrorKey = hasErrors? "import_csv_tasks.result.errors_differ.errors" :"import_csv_tasks.result.errors_differ.errors_and_duplicates";
        }
        this.resultInfoContainer.find(".errorsDiffer").html(messageResource.getMessage("import_csv_tasks.result.errors_differ", [messageResource.getMessage(messageErrorKey)]));
        this.resultInfoContainer.toggleClass("errorsDiffer", errorListWasChanged && (hasDuplicates || hasErrors));
    },

    completeImportSuccessHandler: function(result)
    {
        result.table = this.resultTable;
        var collectedErrors = this.collectRowsWithErrors(result);
        var resultCounters = result["importCounter"];
        _.extend(this.affectedProjectIds, arrayToSet(resultCounters.projectIds));

        var imported = this.resultInfoContainer.find(".importInfoRow");
        var importedTasks = imported[0];
        var newTypes = imported[1];

        var hasDuplicates = collectedErrors.duplicates.length > 0;
        var hasErrors = collectedErrors.errors.length > 0;

        var importPrefix = "<div class='importInfoText'>";

        if(!(hasDuplicates || hasErrors))
            importPrefix = "<div class='successIcon'></div>"+importPrefix;

        var counter = this._makeCounter;
        importedTasks.innerHTML = importPrefix + counter(resultCounters["customersCount"], "common.customer", "common.customers", " / ") +
                                  counter(resultCounters["projectsCount"], "common.project", "common.projects", " / ") +
                                  counter(resultCounters["tasksCount"], "common.task", "common.tasks", "")+'</div>';

        var typeOfWorkAdded = resultCounters.typesOfWorkCount > 0;
        $(newTypes).toggle(typeOfWorkAdded);
        if (typeOfWorkAdded)
        {
            newTypes.innerHTML = importPrefix + counter(resultCounters["typesOfWorkCount"], "common.type_of_work", "common.types_of_work",
                                         "", "import_csv_tasks.result.import_new")+'</div>';
        }

        var failsEl = this.resultInfoContainer.find(".notImported");
        var duplicatesEl = failsEl.find(".duplicatesInfoRow");
        var errorsEl = failsEl.find(".errorsInfoRow");



        this.resultInfoContainer.toggleClass("showNotImported", hasDuplicates || hasErrors);
        this.resultInfoContainer.toggleClass("showOnlyImported", !(hasDuplicates || hasErrors));
        duplicatesEl.toggle(hasDuplicates);
        errorsEl.toggle(hasErrors);

        this.toggleImportDifferNote(collectedErrors);

        var failContent = function(counter, msgKeySingle, msgKeyMultiple, linkId, linkMsgKey)
        {
            var msgKey = (counter == 1) ? msgKeySingle : msgKeyMultiple;
            return "<div class='fixedInfo'><span class='counter'>" + counter + "</span> " +
                   messageResource.getEscapedMessage(msgKey) +
                   "</div><div id='" + linkId + "' class='linkText noDecoration short'>" +
                   messageResource.getEscapedMessage(linkMsgKey) +
                   "</div>";
        };

        if (hasDuplicates)
        {
            var duplicateLinkId = "resultDuplicatesLink";
            duplicatesEl[0].innerHTML = failContent(collectedErrors.duplicates.length, 'import_csv_tasks.text.duplicate', 'import_csv_tasks.text.duplicates',
                                                    duplicateLinkId, "import_csv_tasks.result.download_duplicates");

            this.createCSVWithDuplicatesLink("#" + duplicateLinkId, this.columns, collectedErrors.duplicatesJSON);
        }

        if (hasErrors)
        {
            var errorLinkId = "resultErrorsLink";
            errorsEl[0].innerHTML = failContent(collectedErrors.errors.length, 'import_csv_tasks.text.error', 'import_csv_tasks.text.errors', errorLinkId,
                                                "import_csv_tasks.result.download_errors");
            this.createCSVWithErrorsLink("#" + errorLinkId, this.columns, collectedErrors.errorsJSON);
        }
    },

    _makeCounter: function(counter, singleForm, multipleForm, postfix, prefixKey)
    {
        var key = (counter == 1) ? singleForm : multipleForm;
        var prefix = _.isUndefined(prefixKey) ? "" : (messageResource.getEscapedMessage(prefixKey) + " ");
        return "<span class='counterName'>" + "<span class='counter'>" + counter + "</span> " + prefix +
               messageResource.getEscapedMessage(key) + postfix + "</span> ";
    },

    fillImportInfo: function(resultCounters)
    {
        var counter = this._makeCounter;
        var typeOfWorkAdded = resultCounters.typesOfWorkCount > 0;
        this.toImportInfoContainer[0].innerHTML = counter(resultCounters["customersCount"], "common.customer", "common.customers", ", ") +
                                                  counter(resultCounters["projectsCount"], "common.project", "common.projects", ", ") +
                                                  counter(resultCounters["tasksCount"], "common.task", "common.tasks", typeOfWorkAdded ? ", " : "") +
                                                  (typeOfWorkAdded ? counter(resultCounters.typesOfWorkCount, "common.type_of_work", "common.types_of_work",
                                                                             "", "import_csv_tasks.result.import_new") : "");
    },

    onCSVLoadError: function(resultJSON)
    {
        var exception = resultJSON.errorMessage;

        if (_.isUndefined(exception))
        {
            var errorCode = resultJSON.error;
            var messages = this.errorCodesMessages;
            var codeName = this.errorCodesMap[errorCode];
            var message = _.isUndefined(codeName) || _.isUndefined(messages[codeName]) ? messages["UNEXPECTED_ERROR"] : messages[codeName];

            alert(message);

            if (codeName === "SESSION_EXPIRED" || codeName === "NO_RIGHTS" || codeName === "USER_IS_DISABLED")
                window.location.reload();
        }
    },

    onCSVLoadSuccess: function(resultJSON)
    {
        var result = resultJSON["result"];
        if (_.isUndefined(result))
        {
            this.onCSVLoadError(resultJSON);
            return {success: false};
        }

        this.csvSeparator = result.settings.separator;
        this.encoding = result.settings.encoding;

        var bigDataHandler = this.updateTableData(result);
        return {success: true, handler: bigDataHandler};
    },

    markRowsWithProblems: function(columns, table, errors, className)
    {
        var errLength = errors.length;
        for (var i = 0; i < errLength; i++)
        {
            var rowData = errors[i];
            var rowEl = table.find("#" + this.resultTableRowPrefix + rowData.row.rowId);
            rowEl.removeClass("correct").addClass(className);

            var rowErrors = rowData.error;
            _.each(columns, function(column)
            {
                var errCode = rowErrors[column];
                if (!_.isUndefined(errCode) && errCode != null)
                {
                    var cell = rowEl.find("." + column);
                    cell.addClass("withError");
                    cell.attr("errorType", errCode);
                    cell.attr("column", column);
                    cell.attr("textLength", cell.html().length);
                }
            });
        }
    },

    createLinkText: function(singleMsgKey, msgKey, length)
    {
        var key = ( length == 1 ) ? singleMsgKey : msgKey;
        return "<div class='tableLinkText'><span class='lengthValue'>" + length + "</span> " + messageResource.getEscapedMessage(key) + "</div>";
    },

    createTable: function(data)
    {
        var duplicates = data.duplicates;
        var errors = data.errors;

        var duplicatesLength = duplicates.length;
        var errorsLength = errors.length;
        var successLength = data.table.length - duplicatesLength - errorsLength;

        this.resulTasksSuccessTableLink.get(0).innerHTML = this.createLinkText('common.task', 'common.tasks', successLength);
        this.resultTasksDuplicatesTableLink.get(0).innerHTML = this.createLinkText('import_csv_tasks.text.duplicate', 'import_csv_tasks.text.duplicates',
                                                                                   duplicatesLength);
        this.resulTasksErrorTableLink.get(0).innerHTML = this.createLinkText('import_csv_tasks.text.error', 'import_csv_tasks.text.errors', errorsLength);

        var failsLinkContainer = $("#failsLinkContainer");
        failsLinkContainer.toggleClass("hideDuplicates", duplicatesLength == 0);
        failsLinkContainer.toggleClass("hideErrors", errorsLength == 0);

        this.resultTableContainer[0].innerHTML = this.template(data);

        this.importPreviewSection.removeClass("showDuplicates showErrors").addClass("showCorrect");

        this.addEmptyRowsIfNeeded(successLength, duplicatesLength, errorsLength);
    },

    addScroll: function ()
    {
        var doubleScrollEl = $("#scrollableHeader");
        var scrollableBody = $("#scrollableBody");

        if (isIE8())
        {
            var containerWidth = doubleScrollEl.width();
            scrollableBody.width(containerWidth).css("overflow", "auto");

            var resultTableHeader = $("#resultTableHeader");
            resultTableHeader.css("position", "relative");
            scrollableBody.scroll(function()
                                  {
                                      var scroll = -1 * scrollableBody.scrollLeft();
                                      resultTableHeader.css("left", scroll);
                                  });
        }
        else
        {
            this.verticalScroll = ScrollUtils.addVerticalScroll(scrollableBody, {isFaded: false, appendTo: doubleScrollEl});
            this.horizontalScroll = ScrollUtils.addHorizontalScroll(doubleScrollEl, {isFaded: false, mouseWheel: false});
        }
    },

    addEmptyRowsIfNeeded: function(successTasksNumber, duplicateTasksNumber, errorTasksNumber)
    {
        var emptyRows = $("#resultTable").find(".taskRow.empty");
        var addEmpyRows = function(required, visibleNumber, className)
        {
            var needed = required - visibleNumber;
            for (var i = 0; i < needed; i++)
            {
                var row = $(emptyRows[i]);
                row.addClass(className);
            }
        };

        addEmpyRows(10, successTasksNumber, "correct");
        addEmpyRows(8, duplicateTasksNumber, "duplicate");
        addEmpyRows(8, errorTasksNumber, "withError");
    },

    applyTableScrollHacks: function(columns)
    {
        var columnNamesRow = $("#resultTable").find(".columnNames");
        _.each(columns, function(column)
        {
            var columnCell = columnNamesRow.find("." + column);
            var width = columnCell.width() + 10;
            $(".resultTable .columnNames ." + column).css("min-width", width).css("max-width", width);
            $(".resultTable .taskRow ." + column).css("min-width", width).css("max-width", width);
        });

        columnNamesRow.hide();
    },

    initTableViewLinks: function()
    {
        var section = this.importPreviewSection;
        var self = this;
        var showTableCallback = function(removeClass, addClass)
        {
            section.removeClass(removeClass).addClass(addClass);
            ScrollUtils.refreshCustomScroll(self.verticalScroll);
            ScrollUtils.refreshCustomScroll(self.horizontalScroll);
        };

        this.showDuplicatesFn = function() {showTableCallback("showCorrect showErrors", "showDuplicates")};
        this.showErrorsFn = function() {showTableCallback("showCorrect showDuplicates", "showErrors")};

        this.resulTasksSuccessTableLink.click(function() {showTableCallback("showDuplicates showErrors", "showCorrect")});
        this.resultTasksDuplicatesTableLink.click(this.showDuplicatesFn);
        this.resulTasksErrorTableLink.click(this.showErrorsFn);
    },

    createDownloadCSVLinkFunction: function(fileName, columns, jsonCSV)
    {
        var json = {
            columnNames: this.columnNames,
            columns: columns,
            table: jsonCSV
        };

        return () => downloadJsonAsCSV([json], fileName);
    },

    createCSVWithDuplicatesLink: function(elementId, columns, errors)
    {
        var fn = this.createDownloadCSVLinkFunction("Duplicate_rows.csv", columns, errors);
        $(elementId).off().click(fn);
    },

    createCSVWithErrorsLink: function(elementId, columns, errors)
    {
        var fn = this.createDownloadCSVLinkFunction("Errors.csv", columns, errors);
        $(elementId).off().click(fn);
    },

    getPresentedTableColumns: function(parsedColumns)
    {
        var columns = [];
        var length = this.columnOrder.length;
        for (var i = 0; i < length; i++)
        {
            var columnName = this.columnOrder[i];
            if (_.contains(parsedColumns, columnName))
            {
                columns.push(columnName);
            }
        }

        return columns;
    },

    resultTableRowPrefix: "resultTableRow_",

    createTemplate: function()
    {
        var columnNamesTemplatePart =
                "   <tr class='columnNames'>" +
                "       <td class='icon'>&nbsp;</td>" +
                "       <td class='row'><%=columnNames['rowId']%></td>" +
                "       <%_.each(columns, function(column, index) {%>" +
                "       <td class='<%=column%>'><%=escapeHtmlSymbols(columnNames[column])%></td>" +
                "       <%})%>" +
                "   </tr>";

        var tableTemplate =
                "<div id='scrollableHeader' class='horizontalScroll'><div class='horizontalScrollElementsContainer'>" +
                "   <table id='resultTableHeader' class='resultTable'>" +
                "       <thead class='resultTableHeader'>" +
                columnNamesTemplatePart +
                "       </thead>" +
                "   </table>" +
                "   <div id='scrollableBody' class='verticalScroll'>" +
                "       <table id='resultTable' class='resultTable'>" +
                "           <tbody class='resultTableBody'>" +
                columnNamesTemplatePart +
                "               <%_.each(table, function(row, index) {%>" +
                "               <tr id='" + this.resultTableRowPrefix + "<%=row.rowId%>' class='taskRow correct'>" +
                "                   <td class='icon'>&nbsp;</td>" +
                "                   <td class='row'><%=row['rowId']%></td>" +
                "                   <%_.each(columns, function(columnName, index) {%>" +
                "                   <td class='<%=columnName%>'><%=_.isUndefined(row[columnName]) ? '' : escapeHtmlSymbols(row[columnName])%></td>" +
                "                   <%})%>" +
                "               </tr>" +
                "               <%})%>" +
                "               <% for (var idx = 0; idx < 10; idx++ ) {%>" +
                "               <tr class='taskRow empty'>" +
                "                   <td class='icon'>&nbsp;</td>" +
                "                   <td class='row'>&nbsp;</td>" +
                "                   <%_.each(columns, function(columnName, index) {%>" +
                "                   <td class='<%=columnName%>'>&nbsp;</td>" +
                "                   <%})%>" +
                "               </tr>" +
                "               <%}%>" +
                "           </tbody>" +
                "       </table>" +
                "   </div>" +
                "</div></div>";

        return _.template(tableTemplate);
    },

    initSampleCSV: function()
    {
        var sampleJsonColumns = this.columnOrder;
        var sampleJsonTable = [{customer: "Customer A", project: "Project A1", task: "Task 1", description: "Description 1", deadline: "12/31/2016"},
                               {customer: "Customer A", project: "Project A1", task: "Task 2"},
                               {customer: "Customer B", project: "Project B1", task: "Task 3", "typeOfWork": "Type of Work 3"},
                               {customer: "Customer B", project: "Project B2", task: "Task 4", description: "Description 4", estimate: "40"}];

        var fn = this.createDownloadCSVLinkFunction("Sample.csv", sampleJsonColumns, sampleJsonTable);
        $("#sampleCSVFileLink").off().click(this.popup.wrapEventHandler(fn));
        $("#infoSampleLink").find(".linkText").off().click(fn);
    }
});





// WEBPACK FOOTER //
// ./web/js/addNewTasks/LoadTasksFromCSVManager.js